import { GzTreeWebComponent } from './component/GzTreeWebComponent';
import { WEB_COMPONENT_GZ_TREE } from '../../webcomponents.constants';

export { GzTreeWebComponent };

window.customElements.define(WEB_COMPONENT_GZ_TREE, GzTreeWebComponent);
